import { assignNamespace } from "@gr-common/head/namespace-utils";
import { o_util } from "@gr-common/head/namespaces";
import type { ParameterRecord, ParametersDefinition } from "./data/params.types";
import type { StateDefinition, StateRecord } from "./data/state.types";

/**
 *
 *
 *
 *
 *
 *
 */
export const paramsMap = <P extends ParameterRecord>(
  keys: (keyof P)[],
): ParametersDefinition<P, true> => keys as never;

/**
 *
 *
 *
 *
 *
 */
export const stateMap = <S extends StateRecord>(): StateDefinition<S> => ({}) as never;

/*                                    */
assignNamespace(o_util, "navigation", {
  paramsMap,
  stateMap,
});
